// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qao3K","top":"styles_top__LXTih","left":"styles_left__zI4ml","description":"styles_description__2OGQx"};